import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import {
  formatErrorMessage,
  rejectErrorCodeHelper,
  formatErrorMessageBaseOnCodeIDVerification,
} from '../../util/helpers/registerRejectErrorCodeHelper';
import {
  getIdentificationTypes,
  getAccountFundingDetails,
  createIdentificationInfoRequest,
  updateIdentificationInfoRequest,
} from '../../request/identificationVerificationRequest';
import {
  getIdentificationTypesSuccess,
  getIdentificationTypesError,
  setIdentificationInfoDetails,
  getIdentificationInfoError,
  identificationInfoDataSuccess,
  identificationInfoDataError,
  updateIdentificationInfoDataSuccess,
  updateIdentificationInfoDataError,
} from '../actions/identificationVerification/identificationVerificationActions';
import {
  GET_IDENTIFICATION_TYPES_SOURCE,
  IDENTIFICATION_SOURCE_DETAILS,
  POST_IDENTIFICATION_INFO,
  UPDATE_IDENTIFICATION_INFO,
} from '../actions/identificationVerification/identificationVerificationConstants';

function* fetchIdentificationTypeSource() {
  try {
    const { data } = yield call(getIdentificationTypes);
    yield put(getIdentificationTypesSuccess(data));
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getIdentificationTypesError(errMsg));
  }
}
function* getIdentificationDetails({ payload }) {
  try {
    const { data } = yield call(getAccountFundingDetails, {
      applicationUid: payload.applicationUid,
    });
    if (data) {
      yield put(setIdentificationInfoDetails(data));
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(getIdentificationInfoError(errorMessage));

    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}
function* setIdentifcationInfo({ payload }) {
  try {
    yield call(createIdentificationInfoRequest, {
      applicationUid: payload.applicationUid,
      data: payload.data,
    });
    yield put(identificationInfoDataSuccess(payload.data));
    yield call(payload.onSuccess);
  } catch (error) {
    const { fieldName, errorMessage } = yield call(
      formatErrorMessageBaseOnCodeIDVerification,
      error,
    );
    yield put(identificationInfoDataError(errorMessage));

    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
        field: fieldName,
      });
    }
  }
}

function* updateIdentificationInfo({ payload }) {
  try {
    const { data } = yield call(updateIdentificationInfoRequest, {
      applicationUid: payload.applicationUid,
      data: payload.data,
    });
    yield put(updateIdentificationInfoDataSuccess(data));
    yield call(payload.onSuccess);
  } catch (error) {
    const { fieldName, errorMessage } = yield call(
      formatErrorMessageBaseOnCodeIDVerification,
      error,
    );
    yield put(updateIdentificationInfoDataError(errorMessage));

    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
        field: fieldName,
      });
    }
  }
}

export default function* identificationVerificationSaga() {
  yield all([
    takeLatest(GET_IDENTIFICATION_TYPES_SOURCE, fetchIdentificationTypeSource),
    takeLatest(IDENTIFICATION_SOURCE_DETAILS, getIdentificationDetails),
    takeLatest(POST_IDENTIFICATION_INFO, setIdentifcationInfo),
    takeLatest(UPDATE_IDENTIFICATION_INFO, updateIdentificationInfo),
  ]);
}
